import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ar from './locales/ar.json';
import en from './locales/en.json';

export const defaultNS = 'translation';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: 'ar', // AR is the source of truth (plan §7)
    supportedLngs: ['ar', 'en'],
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      // Respect our own localStorage key + <html lang>, set pre-paint
      order: ['htmlTag', 'localStorage', 'navigator'],
      lookupLocalStorage: 'valion.lang',
      caches: [],
    },
    returnNull: false,
  });

export default i18n;
